exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".one-user-card[data-v-6f669ba9]{display:flex;flex-direction:row;align-items:flex-start;justify-content:flex-start}.user-card[data-v-6f669ba9]{width:300px;text-align:center;background:#fff;padding:12px;box-shadow:0 10px 5px 0 rgba(0,0,0,.05);-webkit-box-shadow:0 10px 5px 0 rgba(0,0,0,.05);-moz-box-shadow:0 10px 5px 0 rgba(0,0,0,.05)}.user-analytic[data-v-6f669ba9]{width:100%;padding-left:25px}.user-analytic-companies[data-v-6f669ba9]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-around;align-items:center;align-content:center}.analytic-type[data-v-6f669ba9]{cursor:pointer}", ""]);

// exports
